const translations = {
  MORE_TAGS: {
    en: 'More Tags',
    fr: 'Plus de Tags',
  },

  LESS_TAGS: {
    en: 'Less Tags',
    fr: 'Moins de Tags',
  },

  YEAR: {
    en: 'Year',
    fr: 'Année',
  },

  MORE_RESULTS: {
    en: 'More results',
    fr: 'Plus de résultats',
  },

  DOWNLOAD: {
    en: 'Download',
    fr: 'Télécharger',
  },

  NAME: {
    en: 'Name',
    fr: 'Nom',
  },

  FIRSTNAME: {
    en: 'Firstname',
    fr: 'Prénom',
  },

  LASTNAME: {
    en: 'Lastname',
    fr: 'Nom',
  },

  ADDRESS: {
    en: 'Address',
    fr: 'Adresse',
  },

  PHONE: {
    en: 'Phone',
    fr: 'Téléphone',
  },

  ZIP_CODE: {
    en: 'Zip code',
    fr: 'Code postal',
  },

  CITY: {
    en: 'City',
    fr: 'Ville',
  },

  COUNTRY: {
    en: 'Country',
    fr: 'Pays',
  },

  EMAIL: {
    en: 'Email',
    fr: 'E-mail',
  },

  WEBSITE: {
    en: 'Website',
    fr: 'Site internet',
  },

  EDIT: {
    en: 'Edit',
    fr: 'Modifier',
  },

  VALIDATE: {
    en: 'Validate',
    fr: 'Valider',
  },

  DELETE: {
    en: 'Delete',
    fr: 'Supprimer',
  },

  UPDATE: {
    en: 'Update',
    fr: 'Mettre à jour',
  },

  STATUS: {
    en: 'Status',
    fr: 'Titre',
  },

  STATUS_EN: {
    en: 'Status (EN)',
    fr: 'Titre (EN)',
  },

  SEE_EVENT: {
    en: 'See the event',
    fr: 'Voir l’évènement',
  },

  DISCOVER_JOB: {
    en: 'Discover the job',
    fr: 'Découvrir le métier',
  },

  READ_NEWS: {
    en: 'Read the news',
    fr: "Lire l'actualité",
  },

  DISCOVER: {
    en: 'Discover',
    fr: 'Découvrir',
  },

  DOWNLOAD_PRESS: {
    en: 'Download',
    fr: 'Télécharger le communiqué',
  },

  KNOW_MORE: {
    en: 'Know more',
    fr: 'En savoir plus',
  },

  CONSULT: {
    en: 'Consult',
    fr: 'Consulter',
  },

  SEE_POST: {
    en: 'See post',
    fr: 'Voir le post',
  },

  CONFIRM_DELETE: {
    en: 'Do you really want to delete this element?',
    fr: 'Etes-vous sûr de vouloir supprimer cet élément ?',
  },

  FILE_TOO_BIG: {
    en: 'File too Big, please select a file less than',
    fr: 'Fichier trop lourd, séléctionnez un fichier de moins de',
  },

  ACTIVITY_ADDED: {
    en: 'activity added',
    fr: 'activité ajoutée',
  },

  ACTIVITIES_ADDED: {
    en: 'activities added',
    fr: 'activités ajoutées',
  },

  RESULT_FOR: {
    en: 'result for',
    fr: 'résultat pour',
  },

  RESULTS_FOR: {
    en: 'results for',
    fr: 'résultats pour',
  },
}

export default key => {
  const string =
    translations[key] && translations[key][window.LANG]
      ? translations[key][window.LANG]
      : 'missing translation'
  return string
}
